import React from "react";
import { useGetSchoolBranchesOptions } from "../../hooks/branchHooks/branch.hooks";
import Dropdown from "../Dropdown/dropdown";
import { DropdownOptions } from "../dropdownOptions";
import { DateField } from "../input/DateField";
import { useGetClassesOptions } from "../../hooks/classHooks/class.hooks";
import { getSelectedOptionFromValue } from "../../Helper/options.helper";
import { ResultTypeDropdown } from "./ResultType.Dropdown";
import InputField from "../input/inputField";

interface Props {
  schoolBranchId?: number | null;
  onBranchSelect?: (branchId: number) => unknown;
  selectedClass?: number | null;
  onClassSelect?: (classId: number) => unknown;
  publishDate: string;
  setPublishDate: (publishDate: string) => unknown;
  resultType: string | null;
  onResultTypeSelect: (resultType: string) => unknown;
  totalAttendance: number | null;
  setTotalAttendance: (totalAttendance: number) => unknown;
  isEdit?: boolean;
}

export const ResultForm = ({
  schoolBranchId,
  onBranchSelect,
  selectedClass,
  onClassSelect,
  publishDate,
  setPublishDate,
  onResultTypeSelect,
  resultType,
  totalAttendance,
  setTotalAttendance,
  isEdit = false,
}: Props) => {
  const { isLoading: isSchoolBranchOptLoading, data: SCHOOL_BRANCH_OPTIONS } =
    useGetSchoolBranchesOptions();

  const { isLoading: isClassOptionsLoading, data: CLASSES_OPTIONS } =
    useGetClassesOptions();

  if (isSchoolBranchOptLoading || isClassOptionsLoading) return <div />;

  return (
    <div className="flex flex-col">
      {!isEdit ? (
        <Dropdown
          label="Select school branch"
          options={SCHOOL_BRANCH_OPTIONS || []}
          selectedOption={getSelectedOptionFromValue(
            SCHOOL_BRANCH_OPTIONS || [],
            schoolBranchId as number,
          )}
          setSelectedOption={(selectedOption: DropdownOptions) => {
            onBranchSelect && onBranchSelect(selectedOption.value as number);
          }}
        />
      ) : (
        <></>
      )}

      {!isEdit ? (
        <Dropdown
          label="Class"
          options={CLASSES_OPTIONS || []}
          selectedOption={getSelectedOptionFromValue(
            CLASSES_OPTIONS || [],
            selectedClass as number,
          )}
          setSelectedOption={(option) => {
            onClassSelect && onClassSelect(option.value as number);
          }}
        />
      ) : (
        <></>
      )}

      {!isEdit ? (
        <ResultTypeDropdown
          onResultTypeSelect={(selectedResultType) => {
            onResultTypeSelect(selectedResultType.value);
          }}
          selectedResultType={resultType}
        />
      ) : (
        <></>
      )}

      <DateField
        date={publishDate}
        setDate={setPublishDate}
        label="Result publish date"
      />

      <InputField
        value={totalAttendance}
        setValue={setTotalAttendance}
        label="Total attendance"
        placeHolder="Enter total attendance"
        type="number"
      />
    </div>
  );
};
